import { render, staticRenderFns } from "./OurEmployees.vue?vue&type=template&id=1801bc00&scoped=true"
import script from "./OurEmployees.vue?vue&type=script&lang=js"
export * from "./OurEmployees.vue?vue&type=script&lang=js"
import style0 from "./OurEmployees.vue?vue&type=style&index=0&id=1801bc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801bc00",
  null
  
)

export default component.exports